export const GET_MERCH_LIST = 'get_merch_list'
export const SET_MERCH_LIST = 'set_merch_list'
export const SET_INDEX = 'set_index'